import moment from "moment";
import Lang from '../translations';

function determineFormat(lang) {
    let format;

    switch (lang) {
        default:
        case 'nl': format = 'dddd D MMMM YYYY'; break;
        case 'en': format = 'dddd, MMMM D YYYY'; break;
    }

    return format;
}

export default function (date) {
    return moment(date).format(determineFormat(Lang.getLocale()));
}
